import React from "react";
import { PaperComponent } from "@/components";
import { Stack, Typography } from "@mui/material";
import {
  CurrencyConverter,
  TimeZoneConverter,
  WEB_COLORS,
} from "@/lib/constants";
import MultiSegmentProgressBar from "../../active-loans/card/multiprogressbar";
import dayjs from "dayjs";

const TopCard = ({
  disbursedDate,
  loanLabel,
  loanAmount,
  totalEmiCount,
  paidEmiCount,
  overDueCount,
}) => {
  const formattedStartDateTime = dayjs(new Date(disbursedDate)).format(
    "DD/MM/YYYY h:mm A",
  );
  return (
    <PaperComponent
      paperStyle={{
        backgroundColor: "rgba(242, 247, 247, 0.6)",
        position: "relative",
        py: 6,
      }}
    >
      <PaperComponent
        paperStyle={{
          position: "absolute",
          top: "-30px",
          left: "-5px",
          borderRadius: "40px",
          p: 1,
        }}
      >
        <Typography variant="caption">
          Disbursal Date:{formattedStartDateTime}
        </Typography>
      </PaperComponent>
      <Stack
        gap={4}
        direction={{ xs: "column", sm: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Stack>
          <Typography variant="h4">{loanLabel}</Typography>
          <Typography variant="h4" fontWeight={"bold"}>
            {CurrencyConverter(loanAmount)}
          </Typography>
          <Typography variant="h6" color={WEB_COLORS.textFadeColor}>
            For {totalEmiCount} months
          </Typography>
        </Stack>
        <Stack flexGrow={1}>
          <MultiSegmentProgressBar
            overdue={overDueCount}
            paid={paidEmiCount}
            tenure={totalEmiCount}
          />
        </Stack>
      </Stack>
    </PaperComponent>
  );
};

export default TopCard;
